<template>
  <div v-if="visible" class="modal-backdrop">
    <div class="modal-content">
      <button class="modal-close-button" @click="closeModal">
        <span class="material-icons">close</span>
      </button>
      <UserListContent :users="filteredUsers" @ban-toggle="onCheckboxToggle" />
      <button style="margin-top: 1rem; width: 100%" @click="closeModal">
        Close
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import UserListContent from "./UserListContent.vue";

defineProps({
  visible: Boolean,
});

const users = defineModel();
const searchQuery = ref("");

const filteredUsers = computed(() => {
  const query = searchQuery.value.trim().toLowerCase();
  if (!query) return users.value;
  return users.value.filter((u) =>
    `${u.first_name} ${u.last_name} ${u.email} ${u.phone}`
      .toLowerCase()
      .includes(query)
  );
});

const $emit = defineEmits(["close", "ban-toggle"]);

function closeModal() {
  $emit("close");
}

function onCheckboxToggle(user) {
  const updated = { id: user.id, is_soft_banned: user.is_soft_banned };
  $emit("ban-toggle", updated);
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  background-color: var(--bg1);
  padding: 24px;
  border-radius: 8px;
  width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.modal-close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.1em;
  min-width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}
.modal-description {
  margin-bottom: 1rem;
  font-size: 0.95rem;
  color: var(--fg0);
  font-style: italic;
}
.modal-user-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.modal-user-item {
  display: flex;
  flex-direction: row;
  padding: 8px 0;
  border-bottom: 1px solid var(--fg0);
}
.user-checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.user-status {
  margin-top: 4px;
  font-size: 0.85rem;
  color: green;
}

.user-status.banned {
  color: #b94a48;
  font-weight: bold;
}
</style>
